import {useEffect, useState} from "react";
import up_arrow from "../../assets/up_arrow.svg";
import down_arrow from "../../assets/down_arrow.svg";
import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";
import valuer_api from "../../api/valuer";


const ValuerAmendAccordion = (props) => {

    const [open, setOpen] = useState(false);

    // Required
    const summaryId = props.summaryId
    const sectionName = props.sectionName
    const enabled = props.enabled
    const fieldList = props.fieldList ? props.fieldList : []
    const identifier = props.identifier

    // Optional
    const hasCard = props.hasCard

    // Functions
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    const [values, setValues] = useState({});

    // Grandparent Based Requirements
    const GetValueFromGrandParentValues = props.GetValueFromGrandParentValues
    const UpdateGrandparentValue = props.UpdateGrandparentValue

    const toggleOpen = () => {
        if (!enabled) return
        setOpen(!open);
    }

    useEffect(() => {
        GetValuesForAccordion()
    }, [summaryId, sectionName]);

    const GetValuesForAccordion = () => {
        if (!summaryId || !sectionName) return;
        let id
        if (identifier) id = identifier
        else id = sectionName
        let response = valuer_api.ValuerAmendGet(summaryId, id);
        response.then(
            response => {
                let _val = response.data.values;
                for (let [key, value] of Object.entries(_val)) {
                    UpdateGrandparentValue(key, value)
                }
                setValues(_val);
            }
        ).catch(() => {
            setErrorTitle("Valuation Request Error")
            setErrorMessage("There was an error getting the Valuation Request - Please Try Again")
        })
    }

    const UpdateParentValue = (identifier, value, rowId=undefined) => {
        if (!identifier) return
        setValues(v => {
            let v_copy = Object.assign({}, v)
            if (rowId && v_copy.hasOwnProperty(identifier)) {
                if (!v_copy[identifier]) v_copy[identifier] = {}
                v_copy[identifier][rowId] = value
            }
            else v_copy[identifier] = value
            return v_copy
        })
        UpdateGrandparentValue(identifier, value)
    }

    return (
        <>
            <div className={"valuer-amend-accordion-container " + (enabled ? ' link' : '') + (open ? ' open' : '')}
                 onClick={() => toggleOpen()}>
                <div className="valuer-amend-accordion-text-container">
                    {sectionName}
                </div>
                <div className="valuer-amend-accordion-arrow-container">
                    <img src={open && enabled ? up_arrow : down_arrow} alt={"arrow"}/>
                </div>
            </div>
            {open && enabled ?
                <div className={"valuer-amend-accordion-content-container" + (hasCard ? ' accordion-card' : '')} >
                    <ValuerAmendFieldListHandler fieldList={fieldList}
                                                 values={values}
                                                 sectionName={identifier}
                                                 summaryId={summaryId}
                                                 setErrorMessage={setErrorMessage}
                                                 setErrorTitle={setErrorTitle}
                                                 UpdateParentValue={UpdateParentValue}
                                                 AddToQueue={AddToQueue}
                                                 RemoveFromQueue={RemoveFromQueue}
                                                 AddToErroredSaves={AddToErroredSaves}
                                                 GetValueFromGrandParentValues={GetValueFromGrandParentValues} />

                </div>
                : null
            }
        </>
    )
}

export default ValuerAmendAccordion